var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full dF fC aS",staticStyle:{"display":"inline-block","border-right":"1px solid rgba(0, 0, 0, 0.1)"}},[_c('LeftNavBar',{staticClass:"f1",attrs:{"items":_vm.sidebarItems,"title":_vm.selectedAppInitial,"selectedValue":_vm.sidebarSelection},on:{"opened":_vm.selectSideBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }